<template>    
    <BaseModal :id="'static-update'" :title="title">
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit_update(single_object.id, global_index)">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="single_object"
                    :array_options="array_options"
                    :for_update="true"
                />
                <CentralButtons />
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormDynamic     from  '@/components/FormDynamic.vue'
import Breadcrumb      from  '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal       from  '@/components/BaseModal'
import CentralButtons  from  '@/components/CentralButtons'
import FormResources   from  './FormResources'

export default {

    name:   'FormModal',
    props: [
        'title',
        'breadcrumb',
        'parent_id',
        'rest_api',
        'array_options',
        'update_mode',
        'global_index',
        'single_object',
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralButtons,
    },

    data(){
        return{
            form_format: FormResources.note_form_format,
        }
    },

    methods:{

    },
    
}
</script>